
  export default {
    name: 'Theme4ExchangeRatePopup',
    data() {
      return {
        modal: false
      }
    },
    methods: {
      getCurrencySymbol(currencyCode) {
        try {
          const currencySymbols = {
            RUB: '₽',
            SGD: 'S$',
            KHR: '៛',
            PHP: '₱',
            MXN: '$',
            BRL: 'R$',
            INR: '₹',
            USDT: '₮',
            MMK: 'K',
            GBP: '£',
            EUR: '€',
            VND: '₫',
            IDR: 'Rp',
            HKD: 'HK$',
            KRW: '₩',
            CNY: '¥',
            JPY: '¥',
            MYR: 'RM',
            USD: '$',
            THB: '฿'
          }
          return currencySymbols[currencyCode]
        } catch (error) {
          return currencyCode
        }
      }
    }
  }
